// =========================================================
// frontend/js/api.js - V12.2 (Local & Global Sync Fix)
// =========================================================

/**
 * 1. ZENTRALE UPDATE-FUNKTIONEN (Super-Admin kompatibel)
 */
window.updateUserInCloud = async function(uid, data) {
    const user = window.currentUser;
    if (!uid || !user) return;

    try {
        if (user.role === 'SUPERADMIN') {
            await db.collection('users').doc(uid).set(data, { merge: true });
        } else {
            if (!user.companyId) return;
            await db.collection('companies').doc(user.companyId).collection('users').doc(uid).set(data, { merge: true });
        }
        console.log("✅ Cloud-Update erfolgreich");
        return true;
    } catch (error) {
        console.error("❌ Fehler beim Cloud-Update:", error);
        throw error;
    }
};

window.updateExistingUserInDB = window.updateUserInCloud;
window.updateUserInAPI = window.updateUserInCloud; 

/**
 * 2. SUPER-ADMIN & GLOBAL SYNC (Master-Logik)
 */

window.fetchAllCompaniesStats = async function() {
    try {
        console.log("📊 API: Starte Deep-Scan der Unternehmen...");
        const snapshot = await db.collection('companies').get();
        
        const stats = await Promise.all(snapshot.docs.map(async (doc) => {
            const data = doc.data();
            const cid = doc.id;

            const userSnap = await db.collection('companies').doc(cid).collection('users').get();
            const userCount = userSnap.size;

            const compStats = data.stats || { totalCO2: 0, hoDays: 0 };
            const totalCO2 = compStats.totalCO2 || 0;
            const totalDays = compStats.hoDays || 0;
            
            const hoRate = userCount > 0 ? Math.round((totalDays / (userCount * 20)) * 100) : 0;

            return {
                id: cid,
                name: data.name || cid,
                industry: data.industry || 'DIVERS',
                userCount: userCount,
                totalCO2: totalCO2,
                totalDays: totalDays,
                engagement: totalDays > 0 ? 100 : 0, 
                hoRate: Math.min(hoRate, 100),
                trustLevel: data.settings?.strictMode ? 'Standard' : 'High Trust'
            };
        }));
        
        console.log(`✅ Deep-Scan abgeschlossen.`);
        return stats;
    } catch (e) {
        console.error("❌ Fehler fetchAllCompaniesStats:", e);
        return [];
    }
};

// =========================================================
// DER FIX: Lokaler Sync für Nutzer, Globaler für SuperAdmins
// =========================================================
window.syncGlobalImpact = async function(forceGlobal = false) {
    const u = window.currentUser;
    if (!u) return;

    console.log("🚀 START: Impact Sync");
    const currentYear = new Date().getFullYear().toString(); 

    try {
        let uSnap, eSnap, cSnap;

        // 1. Unterscheidung: SuperAdmin vs. Normaler Nutzer
        if (u.role === 'SUPERADMIN' && forceGlobal) {
            console.log("🌍 Führe globalen Sync über alle Firmen aus...");
            [uSnap, eSnap, cSnap] = await Promise.all([
                db.collectionGroup('users').get(),
                db.collectionGroup('events').where('status', '==', 'APPROVED').get(),
                db.collection('companies').get()
            ]);
        } else {
            const cid = u.companyId;
            if (!cid) return;
            console.log(`🏢 Führe lokalen Sync für Firma ${cid} aus...`);
            
            [uSnap, eSnap] = await Promise.all([
                db.collection('companies').doc(cid).collection('users').get(),
                db.collection('companies').doc(cid).collection('events').where('status', '==', 'APPROVED').get()
            ]);
            
            // Wir simulieren den Firmen-Snap für die Logik
            cSnap = [{ id: cid, data: () => ({}) }];
        }

        const userMap = {};
        uSnap.forEach(doc => {
            const data = doc.data();
            userMap[doc.id] = data;
            if (data.uid) userMap[data.uid] = data;
        });

        const compMap = {};
        cSnap.forEach(doc => { 
            compMap[doc.id] = { totalCO2: 0, totalMoney: 0, totalTime: 0, hoDays: 0 }; 
        });

        let totalSystemCO2 = 0;

        eSnap.forEach(doc => {
            const e = doc.data();
            const cid = e.companyId || u.companyId; 
            const rawType = (e.type || "").toUpperCase();
            const isHO = (rawType === 'HO' || rawType === 'HOMEOFFICE');
            const isCorrectYear = e.date && e.date.startsWith(currentYear);

            if (cid && compMap[cid] && isHO && isCorrectYear) {
                const eventUser = userMap[e.userId];
                
                let co2 = 0;
                let money = 0;
                let time = 0;

                if (e.moneySavedAtBooking !== undefined && e.timeSavedAtBooking !== undefined) {
                    co2 = parseFloat(e.co2SavedAtBooking) || 0;
                    money = parseFloat(e.moneySavedAtBooking) || 0;
                    time = parseFloat(e.timeSavedAtBooking) || 0;
                } else {
                    const impact = typeof window.calculateImpact === 'function' && eventUser?.commute 
                        ? window.calculateImpact(eventUser.commute, 1, e.co2SavedAtBooking)
                        : { co2Netto: 0, money: 0, time: 0 };
                    
                    co2 = parseFloat(impact.co2Netto) || 0;
                    money = parseFloat(impact.money) || 0;
                    time = parseFloat(impact.time) || 0;
                }

                compMap[cid].totalCO2 += co2;
                compMap[cid].totalMoney += money;
                compMap[cid].totalTime += time;
                compMap[cid].hoDays++;
                
                totalSystemCO2 += co2;
            }
        });

        const batch = db.batch();
        for (const companyId in compMap) {
            // 🔥 FIX: Hier nutzen wir jetzt 'update' anstelle von 'set' mit merge:true
            // Das sorgt dafür, dass die Firestore-Regel 'affectedKeys().hasOnly(['stats'])' exakt greift!
            batch.update(db.collection('companies').doc(companyId), {
                stats: {
                    totalCO2: compMap[companyId].totalCO2,
                    totalMoney: compMap[companyId].totalMoney,
                    totalTime: compMap[companyId].totalTime,
                    hoDays: compMap[companyId].hoDays,
                    lastSync: firebase.firestore.FieldValue.serverTimestamp()
                }
            });
        }

        await batch.commit();
        console.log("✅ SYNC ERFOLGREICH!");
        
        if (window.loadInitialData) await window.loadInitialData();
        if (window.render) window.render();

    } catch (err) {
        console.error("❌ Sync Fehler:", err);
    }
};

window.listenToAllEventsGlobal = function(callback) {
    return db.collectionGroup('events')
        .where('status', '==', 'APPROVED')
        .onSnapshot(snapshot => {
            const allEvents = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
            callback(allEvents);
        }, err => console.error("❌ Globaler Listener Fehler:", err));
};

/**
 * 3. DATEN LADEN (READ)
 */
window.fetchUsers = async function() {
    const u = window.currentUser;
    if (!u) return [];
    try {
        let snapshot;
        if (u.role === 'SUPERADMIN') {
            snapshot = await db.collectionGroup('users').get();
        } else {
            if (!u.companyId) return [];
            snapshot = await db.collection('companies').doc(u.companyId).collection('users').get();
        }
        return snapshot.docs.map(doc => ({ uid: doc.id, ...doc.data() }));
    } catch (e) {
        return [];
    }
};

window.fetchEvents = async function() {
    const user = window.currentUser;
    if (!user || !user.companyId) return [];
    try {
        const snapshot = await db.collection('companies').doc(user.companyId).collection('events').get();
        return snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
    } catch (error) { 
        return []; 
    }
};

window.fetchCO2Factors = async function(companyId) {
    if (!companyId) return null;
    try {
        const doc = await db.collection('companies').doc(companyId).collection('settings').doc('co2_factors').get();
        return doc.exists ? doc.data() : null;
    } catch (e) { return null; }
};

window.fetchRolesFromDB = async function(companyId) {
    if (!companyId) return null;
    try {
        const doc = await db.collection('companies').doc(companyId).collection('settings').doc('roles').get();
        return doc.exists ? doc.data() : null; 
    } catch (error) { return null; }
};

window.fetchStatusTypes = async function(companyId) {
    if (!companyId) return [];
    try {
        const snapshot = await db.collection('companies').doc(companyId).collection('statusTypes').get();
        return snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
    } catch (error) { return []; }
};

/**
 * 4. RECHTE & ROLLEN
 */
window.updateUserRoleInDB = async function(uid, newRole) {
    return window.updateUserInCloud(uid, { role: newRole });
};

window.updateUserExtraPermissionsInDB = async function(uid, permissionsArray) {
    return window.updateUserInCloud(uid, { extraPermissions: permissionsArray });
};

window.updateUserScopesInDB = async function(uid, scopesObject) {
    return window.updateUserInCloud(uid, { managedScopes: scopesObject });
};

window.updateRoleTemplateInDB = async function(companyId, roleName, permissionsArray) {
    if (!companyId || !roleName) return;
    try {
        await db.collection('companies').doc(companyId).collection('settings').doc('roles').set({
            [roleName]: permissionsArray
        }, { merge: true });
    } catch (error) { throw error; }
};

/**
 * 5. STRUKTUR & STATUS
 */
window.loadOrgStructureFromCloud = async function(companyId) {
    if (!companyId) return [];
    try {
        const doc = await db.collection('companies').doc(companyId).collection('settings').doc('structure').get();
        return doc.exists && Array.isArray(doc.data().tree) ? doc.data().tree : [];
    } catch (error) { return []; }
};

window.saveOrgStructureToCloud = async function(companyId, treeData) {
    if (!companyId) return;
    try {
        await db.collection('companies').doc(companyId).collection('settings').doc('structure').set({
            tree: treeData,
            lastUpdated: new Date()
        });
        return true;
    } catch (error) { throw error; }
};

window.saveStatusTypeToDB = async function(companyId, statusData) {
    if (!companyId || !statusData) return;
    try {
        await db.collection('companies').doc(companyId).collection('statusTypes').doc(statusData.id).set(statusData, { merge: true });
        return true;
    } catch (error) { throw error; }
};

/**
 * 6. BUCHUNGEN & USER-MANAGEMENT
 */
window.saveEventToAPI = async function(eventData) {
    const cid = eventData.companyId || window.currentUser?.companyId;
    if (!cid) return;
    try {
        const eventRef = db.collection('companies').doc(cid).collection('events');
        const snapshot = await eventRef
            .where('userId', '==', eventData.userId)
            .where('date', '==', eventData.date)
            .get();
            
        const batch = db.batch();
        snapshot.forEach(doc => batch.delete(doc.ref));
        
        const newEventRef = eventRef.doc();
        batch.set(newEventRef, {
            ...eventData,
            createdAt: eventData.createdAt || Date.now()
        });
        await batch.commit();
        return newEventRef.id;
    } catch (error) { throw error; }
};

window.deleteEventFromAPI = async function(userId, dateStr) {
    const user = window.currentUser;
    if (!user?.companyId) return;
    try {
        const snapshot = await db.collection('companies').doc(user.companyId)
            .collection('events')
            .where('userId', '==', userId)
            .where('date', '==', dateStr)
            .get();
        const batch = db.batch();
        snapshot.forEach(doc => batch.delete(doc.ref));
        await batch.commit();
    } catch (error) { throw error; }
};

window.createNewUserInDB = async function(userData) {
    console.log("🚨 Aktueller User im Frontend:", firebase.auth().currentUser);

    const admin = window.currentUser;
    try {
        const dataToSend = {
            ...userData,
            companyId: admin.companyId
        };

        // KORREKTUR: Erst .app(), dann .functions('region')
        const createUserServerFunc = firebase.app().functions('europe-west3').httpsCallable('createUser');
        
        console.log("📡 Sende Anfrage an Frankfurt (europe-west3)...");
        const response = await createUserServerFunc(dataToSend);

        console.log("✅ User erfolgreich erstellt. UID:", response.data.uid);
        return response.data.uid;

    } catch (error) { 
        console.error("Cloud Function Fehler Details:", error);
        throw error; 
    }
};

window.deleteSeriesFromAPI = async function(userId, seriesId) {
    const user = window.currentUser;
    if (!user?.companyId || !seriesId) return;
    try {
        const snapshot = await db.collection('companies').doc(user.companyId)
            .collection('events')
            .where('userId', '==', userId)
            .where('seriesId', '==', seriesId)
            .get();
        const batch = db.batch();
        snapshot.forEach(doc => batch.delete(doc.ref));
        await batch.commit();
        return true;
    } catch (error) { throw error; }
};

/**
 * 7. LIVE-LISTENERS
 */
window.listenToEvents = function(callback) {
    const user = window.currentUser;
    if (!user || !user.companyId) return;
    return db.collection('companies').doc(user.companyId).collection('events')
      .onSnapshot((snapshot) => {
          const liveEvents = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
          callback(liveEvents); 
      }, (error) => console.error(error));
};

window.exportStatsToCSV = function() {
    const u = window.currentUser;
    let evs = window.events || [];
    
    if (!u) return;

    if (u.role !== 'SUPERADMIN') {
        evs = evs.filter(e => e.companyId === u.companyId);
    }

    if (evs.length === 0) {
        window.showToast("Keine Daten für deine Firma gefunden.", true);
        return;
    }

    let csvContent = "Tag;Firma;User;CO2_Ersparnis\n";
    const reportData = evs.filter(e => e.status === 'APPROVED' && (e.type === 'HO' || e.type === 'homeoffice'));

    reportData.forEach(e => {
        csvContent += `${e.date};${e.companyId};${e.userId};${(parseFloat(e.co2SavedAtBooking) || 0).toFixed(2)}\n`;
    });

    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement("a");
    link.setAttribute("href", URL.createObjectURL(blob));
    link.setAttribute("download", `presenzo_export_${u.companyId || 'global'}.csv`);
    link.click();
    
    window.showToast("Dein Firmen-Export ist bereit!");
};